/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal, Button, Dropdown, Nav, Overlay, OverlayTrigger, Popover, Form, Spinner } from 'react-bootstrap';
import {biddernotificationList, notificationSseEvent, updateNotication } from './../../../../shared/settings/apiconfig';
import { getBuyersUrl, getBuyerHeaders, getPaymentUrl } from './../../../../shared/http';
import axios from 'axios';
import store from 'features/store'; 

import './Header.scss';
import {
    biddingDark,
    biddingWhite,
    FavoriteDark,
    FavoriteWhite,
    image_thumbnail,
    myAccountDark,
    myAccountWhite,
    notWonDark,
    notWonWhite,
    watchingDark,
    watchingWhite,
    wonDark,
    wonWhite
} from 'shared/images/images';
import { isAuthorized } from 'shared/settings/auth';
import { SellWithUsLink } from 'shared/settings/config';
import { titleCase } from 'shared/modifiers';
import { LocationService } from 'shared/services'; 
import { addDataLayer } from 'shared/utils/utils';



/**
 * defines header once login is made
 * 
 * @param props
 * 
 * @returns html code for rendering header after login
 * 
**/
class Header extends Component {

    constructor(props) {
        super(props);
        this.estateHistoryPopoverRef = createRef();
        this.desciptionPopoverRef = createRef();

        this.state = {
            current_path: '',
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            estateHistoryPopoverShow: false,
            estateHistoryTarget: null,
            searchValue: '',
            logoWidth: 265,

            /* Description popover */
            locationPopoverShow: false,
            locationPopoverTarget: false,
            disableLocationPopoverClose: false,
            locationScrollButtons: { disableTop: true, disableDown: false },

            globalSearchToggle: false,
            notificationList:[],
            notificationShow: false
        }
    }

    async componentDidMount() {
        this.setSearchBoxValue();
        this.setState({
            current_path: this.props.location.pathname
        });
        window.addEventListener('resize', this.setHeight);
        this.setHeight();
        this.sseEventListener();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            const current_path = this.props.location.pathname;
            const check = current_path.includes('view-more-items') ? current_path.split('/').length === 3 : false;
            this.setState({
                current_path: this.props.location.pathname,
                searchValue: check ? this.props.location.searchValue ? this.props.location.searchValue : this.state.searchValue : ''
            }, () => {
                if (check && !this.state.searchValue) { this.setSearchBoxValue(); }
            });
        }

        if (prevProps.user.id != this.props.user.id) {
            this.setState({
                notificationList: []
            }, ()=> {
                if (this.eventSource) {
                    this.eventSource.close();
                }
                this.sseEventListener();
            });  
        }

        window.addEventListener('resize', this.setHeight);
    }

    onLogoutUser = () => {
        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: true });
    };

    onSidebarToggle = () => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: true });
    };

    onCustomSibdebarToggle = () => {
        store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: !this.props.customSidebar.open } });
    }

    registerModalOpen = () => {
        store.dispatch({ type: 'TOGGLE_REGISTER_MODAL', payload: true });
    }
    signInOpen = (flag) => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: flag } });
    }

    navigate = (flag) => {
        this.props.history.push(flag);
    }

    navigateEventStop(event, flag) {
        event.preventDefault();
        // event.stopPropagation();
        this.navigate(flag);
    }

    active = (flag) => {
        const param = this.state.current_path.split('/');
        const paths = param.includes("estate-sale") && param.includes("item") && param.length === 6 ? Buffer.from(param[5], "base64").toString("ascii").split('/') : param;
        return paths.includes(flag);
    }
    setHeight = () => {
        const logoBox = document.getElementsByClassName('logo-box')[0];
        let getWidth = logoBox ? logoBox.clientWidth + 15 : 265;
        getWidth = getWidth < 100 ? 265 : getWidth;
        this.setState({
            innerWidth: window.innerWidth,
            logoWidth: getWidth,
            innerHeight: window.innerHeight
        });
    }

    sellWithUs = () => {
        window.open(SellWithUsLink, '_blank');
        let dataLayerData = {
            'event': 'sell_with_us'
        }
        addDataLayer(dataLayerData); 
    }

    viewMoreItems = (event) => {
        event.preventDefault();
        const value = this.state.searchValue;
        if (value) {
            if (this.state.current_path.includes("view-more-items") && this.state.current_path.split('/')[2] === value) {
                store.dispatch({ type: 'UPDATE_NLP_SEARCH', payload: !this.props.nlpSearch });
            } else {
                if ( this.props.history.location.pathname.includes('/view-more-items') ) {
                    this.props.history.replace({pathname: `/view-more-items/${value}`, searchValue: value});
                } else {
                    this.props.history.push({pathname: `/view-more-items/${value}`, searchValue: value});
                }
            }
            this.globalSearchCancel();
        }
    }

    onChange = (event) => {
        this.setState({
            searchValue: event.target.value
        });
    }

    openInNewTab = (url) => {
        if (url) {
            const reformat = url.includes('http') ? url : 'http://' + url;
            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
    }

    /* Called when title button hover */
    locationPopoverHanlde = (event, flag) => {

        /* Mouse enter */
        if (event.type === "mouseenter") {
            if (flag === 'Popover-Div') {
                this.setState({ disableLocationPopoverClose: true });
            } else {
                this.setState({ locationPopoverShow: true, locationPopoverTarget: event.target });
            }
        }

        /** Mouse Leave */
        else if (event.type === "mouseleave") {
            if (flag === 'Popover-Div') {
                this.setState({ disableLocationPopoverClose: false });
            }
            setTimeout(() => {
                if (!this.state.disableLocationPopoverClose) {
                    this.setState({ locationPopoverShow: false });
                }
            }, 1500);
        }
    }

    myAccountActive = () => {
        const notIn = ['/my-account/watching', '/my-account/bidding', '/my-account/won', '/my-account/not-won', '/my-account/favorite-locations'];
        const paths = this.state.current_path.split('/');
        const check = paths.includes('my-account');
        const isInvoiceScreen = paths.includes('invoice') && paths.includes('view');
        const final = check && !isInvoiceScreen ?
            notIn.every(path => !`${this.props.location.pathname}`.includes(path)) : false;
        return final;
    }

    openChatBot = () => {
        var iframe = document.getElementById('jsd-widget');
        var innerDoc = (iframe.contentDocument) ? iframe.contentDocument : iframe.contentWindow.document;
        const a = innerDoc.getElementById("help-button");
        if (a) {
            a.click();
        } else {
            /**
             * This will call when opened or Not found time.
             * 
             * Note:- search-container will come after chatbot open.
             */
            // const searchContainer = innerDoc.getElementById("search-container");

        }
    }

    setSearchBoxValue = () => {
        const current_path = this.props.location.pathname;
        if (current_path.includes('view-more-items')) {
            if (current_path !== "view-more-items") {
                const value = current_path.split('/')[2];
                this.setState({ searchValue: value });
            }
        }
    }

    showGlobalSearch = () => {
        this.setState({ globalSearchToggle: !this.state.globalSearchToggle });
    }

    globalSearchCancel = () => {
        this.setState({ globalSearchToggle: false });
    }

    favoriteLocation = (event) => {
        event.stopPropagation();
        event.preventDefault();
        const value = event.target.checked;

        this.setState({
            locationInProgress: true
        }, () => {
            if (value) {
                this.addFavoriteLocation();
            } else {
                this.removeFavoriteLocation();
            }
        });

    }
    isFavoriteLocation = () => {
        const locationId = this.props?.showEstateDetail?.extraData?.sale?.locationid;
        const result = locationId ? this.props?.showEstateDetail?.extraData?.favoriteLocations?.findIndex(x => x.locationid === locationId) > -1 : false;
        return !!result;
    }

    addFavoriteLocation = () => {
        const location = this.props?.showEstateDetail?.extraData?.sale?.locationid;
        const postData = { "data": { "locationid": location } };
        LocationService.addFavoriteLocation(postData).then(res => {
            const favoriteLocations = this.props?.showEstateDetail?.extraData?.favoriteLocations;
            const data = res.data.data[0];
            data['buyerid'] = this.props.user.id;
            favoriteLocations.push(data);

            store.dispatch({
                type: 'SHOW_ESTATE_DETAIL', payload: {
                    show: true,
                    extraData: {
                        sale: this.props?.showEstateDetail?.extraData?.sale,
                        location: this.props?.showEstateDetail?.extraData?.location,
                        locationImage: this.props?.showEstateDetail?.extraData?.locationImage,
                        favoriteLocations: favoriteLocations
                    }
                }
            });
            store.dispatch({ type: 'UPDATE_FAVORITE_LOCATION', payload: true });
            this.setState({
                locationInProgress: false
            });
        }).catch(error => {
            this.setState({
                locationInProgress: false
            });
        });
    }

    removeFavoriteLocation = () => {
        const location = this.props?.showEstateDetail?.extraData?.sale?.locationid;
        const favoriteLocations = this.props?.showEstateDetail?.extraData?.favoriteLocations;
        const locationData = favoriteLocations.findIndex(x => x.locationid === location);
        const postData = { "data": { "locationIds": [{ "id": location }] } };
        LocationService.deleteFavoriteLocation(postData).then(res => {
            favoriteLocations.splice(locationData, 1);
            store.dispatch({
                type: 'SHOW_ESTATE_DETAIL', payload: {
                    show: true,
                    extraData: {
                        sale: this.props?.showEstateDetail?.extraData?.sale,
                        location: this.props?.showEstateDetail?.extraData?.location,
                        locationImage: this.props?.showEstateDetail?.extraData?.locationImage,
                        favoriteLocations: favoriteLocations
                    }
                }
            });
            store.dispatch({ type: 'UPDATE_FAVORITE_LOCATION', payload: true });
            this.setState({
                locationInProgress: false
            });
        }).catch(error => {
            this.setState({
                locationInProgress: false
            });
        });
    }

    /* SSE Event  */
    sseEventListener = () => {
        try {
            const buyerId = this.props.user.id;
            if (buyerId) {
                this.eventSource = new EventSource(`${getPaymentUrl(notificationSseEvent)}${buyerId}`);
                this.eventSource.onmessage = (event) => this.updateNotificationSse(event);
                // this.eventSource.onopen = (event) => this.postCall(event, buyerId);
                this.eventSource.onerror = (event) => console.clear();
            }
        } catch (e) {
            console.error(e);
        }
    }

    updateNotificationSse = () => {
        try {
            this.getNotificationList();
        } catch (e) {
            console.error(e);
        }
    }
      /* Get Notification list data */
  
    getNotificationList = () => {
        const data = {
            filter: [
                { field: 'status', value: 0, op: '=', join: 'AND' }
            ]
        }; 
        axios.post(getBuyersUrl(`${biddernotificationList}`), JSON.stringify(data), getBuyerHeaders())
            .then(response => {
                         
                
                this.setState({
                    notificationList:response.data.data
                }, () => {
                   
                });
            })
    }
    updateNotication = async (key) => {
        let data = {}
        if (key) {
              data = {
                data: {
                    status: 1,
                    id: key.id,
                    clearall: false
                }
            };
        } else {
              data = {
                data: {
                    status: 1,
                    clearall: true
                }
            };

        }
     /*    this.setState({ pageLoading: true }); */
        await axios.put(getBuyersUrl(updateNotication), JSON.stringify(data), getBuyerHeaders())
            .then(response => {

                // TODO: success message handle
                if(response.data.status=='success'){
                                      
                    this.setState({
                        notificationShow: key ? true : false,
                        notificationList: key ? this.state.notificationList.filter((item) => item.id !== key.id) : []
                    }, () => {

                    });

                }
                
            })
            .catch(error => {
               /*  this.setState({ pageLoading: false }); */
                // TODO: Error message handle
            });
    }

    navigateToScreen = (res) => {
        if(res.route == 'INVC' || res.route == 'TRAN') {
            this.props.history.push('my-account/invoice/' + res.invcId + '/view');
        } else if(res.route == 'PAYMENT' || res.route == 'PYMT') {
            this.props.history.push('my-account/my-info/payment-methods');
        } else if(res.route == 'ITMDETAIL' || res.route == 'MSG') {
            this.props.history.push('estate-sale/'+ res.saleId + '/item/' + res.itemId);
        } else if(res.route == 'WSHLIST') {
            this.props.history.push('my-account/watching');
        } else if (res.route == 'BIDWON') {
            this.props.history.push('my-account/won')
        }
    }

    render() {

        return (
            <div className="header-main-div">
                <div className="d-flex flex-row header-box border-bottom border-outline">
                    <div className={`d-flex flex-row  align-items-center logo-box`}>
                        <div className="d-block flex-row align-items-center logo">
                            <a onClick={(event) => this.navigateEventStop(event, '/')} className="logo-link" href="/">
                               {this.props?.user?.membershipCompleted ? <img src={`${process.env.PUBLIC_URL}/static/logo/premiermember.png`} alt="logo" className="membership-logo-image" /> : <img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="logo" className="logo-image" /> }
                            </a>
                        </div>
                        {
                            this.props.sidebar ?
                                <div className="d-flex d-lg-none flex-row align-items-center justify-content-center sidebar-toggle sidebar-icon clickable" onClick={this.onSidebarToggle}>
                                    <i className="fa fa-bars"></i>
                                </div> :
                                null
                        }
                        {
                            this.props.customSidebar.icon ?
                                <div className="d-flex d-lg-none flex-row align-items-center justify-content-center sidebar-toggle sidebar-icon clickable" onClick={this.onCustomSibdebarToggle}>
                                    <i className="fa fa-bars"></i>
                                </div> :
                                null
                        }
                    </div>
                    <div className="d-none d-lg-block flex-row align-items-center justify-content-end w-100">

                        <div className="d-flex flex-row align-items-center justify-content-between tool-box">
                            <Nav className="justify-content-center nav-bar-handle">
                                {/* <Nav.Item className={this.props.location.pathname === '/' ? 'active' : ''}>
                                    <Link to="/" className="nav-link">Home</Link>
                                </Nav.Item> */}
                                <Nav.Item className={this.active('advance-search') ? 'active' : ''}>
                                    <Link to="/advance-search" className="nav-link">Search</Link>
                                </Nav.Item>
                                <span style={{width: '3px', height:'15px',marginTop:'10px',backgroundColor:'#D0DF00'}} className=''></span>
                                <Nav.Item className={this.active('estate-sale') ? 'active' : ''}>
                                    <Link to="/estate-sale/list" className="nav-link">Estate Sales</Link>
                                </Nav.Item>
                                <span style={{width: '3px', height:'15px',marginTop:'10px',backgroundColor:'#D0DF00'}} className=''></span>
                                <Nav.Item className={this.active('locations') || this.active('estate-sales') ? 'active' : ''}>
                                    <Link to="/locations" className="nav-link">Locations</Link>
                                </Nav.Item>
                                <span style={{width: '3px', height:'15px',marginTop:'10px',backgroundColor:'#D0DF00'}} className=''></span>
                                <Nav.Item className={this.active('ourstory')  ? 'active' : ''}>
                                    <Link to="/ourstory" className="nav-link">Our Story</Link>
                                </Nav.Item>
                                <span style={{width: '3px', height:'15px',marginTop:'10px',backgroundColor:'#D0DF00'}} className=''></span> 
                                 <Nav.Item className={this.active('premiermembership')  ? 'active' : ''}>
                                    <Link to={this.props?.user?.membershipCompleted ? "/my-account/premier/premier-membership" : "/premier-membership" } className="nav-link">{this.props?.user?.membershipCompleted? `Your Premier Membership` : `Premier Membership`}</Link>
                                </Nav.Item>
                                { this.state.innerWidth > 992 ? <Form onSubmit={this.viewMoreItems}>
                                    <div className={`search-box ${this.props.searchBoxShow && this.state.innerWidth > 992 ? 'visible' : 'invisible'}`}>
                                        <div className="input-group" style={{ marginTop: '3px' }}>
                                            <input className="form-control py-2" id="advance-sale-search-input" aria-label='Search all items on CTBids' placeholder="Search all items on CTBids" value={this.state.searchValue} onChange={this.onChange}></input>
                                            <span className="input-group-append align-items-center clickable" onClick={this.viewMoreItems}>
                                                <i className="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </Form> : '' }
                            </Nav>
                            <div className={`header-right-button d-flex flex-row align-items-center justify-content-end ${isAuthorized() ? "login" : "unAuth"}`}>
                                {
                                    this.props.networkSlow ?
                                        <div className="slow-network-container">
                                            <OverlayTrigger
                                                trigger={['hover', 'focus']}
                                                placement="bottom-end"
                                                overlay={
                                                    <Popover className="slownetwork-popover">
                                                        <Popover.Content>
                                                            <h4>Pages may run slower over low bandwidth.</h4>
                                                        </Popover.Content>
                                                    </Popover>
                                                }
                                            >
                                                <div><i className="fas fa-wifi text-warning"></i></div>
                                            </OverlayTrigger>
                                        </div> : null
                                }

                                {!this.props.user['id'] ?
                                    <div className="d-flex" >
                                        <Button className="singin-button" type="button" size="sm" style={{ width: '100%', border:'none' }} onClick={() => this.signInOpen('Sign-In')}>Sign In / Register</Button>
                                        {/* <Button variant="secondary" size="sm" className="register-button" onClick={() => this.signInOpen('Sign-Up')}>Register</Button> */}
                                    </div> :
                                    <div className="d-flex align-items-center">
                                        <div class="notification">
                                        <div class="notBtn" href="#"> 
                                               <span className={`fa-stack fa-2x ${this.state.notificationList.length == 0 ? 'fa-stack-empty' : ''}`} data-count={this.state.notificationList.length} style={{ width: '1.5em' }}>
                                                    <i className="fa fa-bell" style={ this.state.notificationList.length > 0 ? {transform: 'rotate(20deg)'} : {}}></i>
                                                </span>  
                                                <div className="notification-wrapper">
                                                    {
                                                        this.state.notificationList.length > 0 ? <div className='notification-drawer'>
                                                        <div class="clearAll" style={{ cursor: 'pointer' }} onClick={() => this.updateNotication(null)}> Clear All</div>
                                                        {this.state.notificationList.map(res => {
                                                            return (
                                                                <div class="sec" key={res.id}>
                                                                    <div class="txt" onClick={() => {this.navigateToScreen(res)}}>{res.description}</div><div class="close" onClick={() => this.updateNotication(res)}> <i className="fa fa-times" style={{ cursor: 'pointer',color: '#A50050' }} aria-hidden="true"></i></div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div> : ''
                                                    }
                                                </div>
                                            </div>                                          
                                        </div>

                                        <div className={`${this.state.innerWidth > 1320 ? 'd-lg-flex' : 'd-none'} user-details`}>
                                            <div className="user-name">
                                                <span style={{ fontSize: '13px' }}>{`${this.props['user']['lastName'] ? this.props['user']['lastName'] + ', ' : ''}${this.props['user']['firstName'] ? this.props['user']['firstName'] : ''}`}</span>
                                            </div>
                                        </div>
                                        <div className="d-none d-lg-flex profile-border-outer justify-content-center">
                                            <Link to="/my-account/my-info/personal-info">
                                                {
                                                    this.props['user']['profileImage'] ?
                                                        <img src={this.props['user']['profileImage']} alt="profile-image" height="34" width="34" /> :
                                                        <img src={process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg'} alt="profile-image" height="34" width="34" className="profile" />
                                                }
                                            </Link>
                                        </div>
                                        <Button variant="dark" size="sm" onClick={this.onLogoutUser} className="logout-button">
                                            <img src="/static/icons/header/logout.svg" alt="logout-image" height="18px" width="18px" className="logout-button-icon" />
                                            <span className="logout-button-name">Sign Out</span>
                                        </Button>
                                    </div>
                                }
                                <Button className="sell-with-us" size="sm" onClick={this.sellWithUs}>Sell With Us</Button>
                                <div className="help-button-main" onClick={this.openChatBot}><i className="fas fa-question"></i></div>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-block d-lg-none flex-row align-items-center justify-content-end w-100">
                        <div className="d-flex flex-row align-items-center justify-content-end tool-box">
                            {
                                this.props.networkSlow ?
                                    <div className="slow-network-container padding">
                                        <OverlayTrigger
                                            trigger={['hover', 'focus']}
                                            placement="bottom-end"
                                            overlay={
                                                <Popover className="slownetwork-popover">
                                                    <Popover.Content>
                                                        <h4>Pages may run slower over low bandwidth.</h4>
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <div><i className="fas fa-wifi text-warning"></i></div>
                                        </OverlayTrigger>
                                    </div> : null
                            }
                            {
                                this.props.searchBoxShow ?
                                    <Button  style={{ backgroundColor: '#71c5e8', color:'white' }} aria-label='global search button' className="global-search-button" onClick={this.showGlobalSearch}>
                                        <i className="fas fa-search"></i>
                                    </Button> : null
                            }

                            <Button variant="dark" className="d-none d-lg-flex logout-button" onClick={this.onLogoutUser}>
                                <img src="/static/icons/header/logout.svg" alt="logout-image" height="18px" width="18px" className="logout-button-icon" />
                                <span className="logout-button-name">Sign Out</span>
                            </Button>
                            <div className="help-button-main" onClick={this.openChatBot}><i className="fas fa-question"></i></div>
                            <div class="notification" style={{ paddingLeft: '5px', display: 'flex', textAlign: 'center' }}>
                                <div class="notBtn" href="#" onClick={() => this.setState({notificationShow: true})} >
                                    <span className={`fa-stack fa-2x ${this.state.notificationList.length == 0 ? 'fa-stack-empty' : ''}`} data-count={this.state.notificationList.length} style={{ width: '1.5em' }}>
                                        <i className="fa fa-bell" style={ this.state.notificationList.length > 0 ? {transform: 'rotate(20deg)'} : {}}></i>
                                    </span> 
                                </div>
                            </div>
                            <Dropdown className={`quick-link ${this.props.user.profilecompleted === 0 ? 'not-completed' : ''}`} style={{ zIndex: 10 }}>
                                <Dropdown.Toggle id="quickLinks" className="bg-white border-0">
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/header/menu.svg`} alt="menu-image" height="25px" width="25px" onClick={this.globalSearchCancel} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="shadow dropdown-menu-full md-screen" style={{ maxHeight: `${this.state.innerHeight - 150}px` }}>
                                    {/* <Dropdown.Item as={Link} to="/" style={{ textDecoration: 'none' }}>
                                        <Link to="/" className="nav-link">Home</Link>
                                    </Dropdown.Item> */}
                                    {/* <Dropdown.Divider /> */}
                                    <Dropdown.Item as={Link} to="/advance-search" style={{ textDecoration: 'none' }}>
                                        <Link to="/advance-search" className="nav-link">Advanced Search</Link>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item as={Link} to="/estate-sale/list" style={{ textDecoration: 'none' }}>
                                        <Link to="/estate-sale/list" className="nav-link">Estate Sales</Link>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item as={Link} to="/locations" style={{ textDecoration: 'none' }}>
                                        <Link to="/locations" className="nav-link">Locations</Link>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item as={Link} to="/ourstory" style={{ textDecoration: 'none' }}>
                                        <Link to="/ourstory" className="nav-link">Our Story</Link>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item as={Link} to="/premier-membership" style={{ textDecoration: 'none' }}>
                                        <Link to={this.props?.user?.membershipCompleted ? "/my-account/premier/member-benefits" : "/premier-membership" } className="nav-link">{this.props?.user?.membershipCompleted? `Your Premier Membership` : `Premier Membership`}</Link>
                                    </Dropdown.Item>
                                   
                                    {/* <Dropdown.Divider />
                                    <Dropdown.Item as={Link} to="/vipmembership" style={{ textDecoration: 'none' }}>
                                        <Link to="/vipmembership" className="nav-link">VIP Membership</Link>
                                    </Dropdown.Item> */}
                                    {
                                        isAuthorized() ? <div>

                                            <Dropdown.Divider />
                                            <Dropdown.Item style={{ textDecoration: 'none' }} className="sub-nav-items">
                                               {this.props.user.membershipCompleted ? <div className="nav-link" onClick={() => this.navigate("/my-account/premier/member-benefits")}>My Premier Benefits</div> : <div onClick={() => this.navigate("/my-account/join-premier-member")} className="nav-link">Become a Premier Member</div>}
                                               {this.props.user.membershipCompleted ? <>
                                                {/* <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/member-benefits")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/member-benefits" className="nav-link">Member Benefits</Link>
                                                </div> */}
                                                {/* <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/member-benefits")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/member-benefits" className="nav-link">Make It Returnable</Link>
                                                </div> */}
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/delivery-guarantee")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/delivery-guarantee" className="nav-link">Delivery Guarantee</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/total-access")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/total-access" className="nav-link">Total Access</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/worthpoint")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/worthpoint" className="nav-link">WorthPoint</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/auction-sneak-peak")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/auction-sneak-peak" className="nav-link">Auction Sneak Peek</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/advisor")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/advisor" className="nav-link">Premier Advisor</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/premier-account")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/premier-account" className="nav-link">Premier Account</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/premier/alzheimers-foundation")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/premier/alzheimers-foundation" className="nav-link">Alzheimer's Foundation</Link>
                                                </div>                                          
                                                </> : ''}
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item style={{ textDecoration: 'none' }} className="sub-nav-items">
                                                <div className="nav-link">My Account</div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/my-info/personal-info")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/my-info/personal-info" className="nav-link">Personal Info</Link>
                                                    { !this.props.user.profilecompleted ? <div className='bg-danger text-white rounded-circle text-center' style={{ right: '35px', bottom: '-2px', paddingRight: '2px', width: '25px', height: '25px', fontWeight: 900 }}>!</div> : null }
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/my-info/personal-interests")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/my-info/personal-interests" className="nav-link">Personal Interests</Link>
                                                    { !this.props.user.interestCompleted ? <div className='bg-danger text-white rounded-circle text-center' style={{ right: '35px', bottom: '-2px', paddingRight: '2px', width: '25px', height: '25px', fontWeight: 900 }}>!</div> : null }
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/my-info/payment-methods")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/my-info/payment-methods" className="nav-link">Payment Methods</Link>
                                                    { !this.props.user.paymentcompleted ? <div className='bg-danger text-white rounded-circle text-center' style={{ right: '35px', bottom: '-2px', paddingRight: '2px', width: '25px', height: '25px', fontWeight: 900 }}>!</div> : null }
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/my-info/change-password")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/my-info/change-password" className="nav-link">Change Password</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/my-info/tax-exemptions")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/my-info/tax-exemptions" className="nav-link">Tax Exemptions</Link>
                                                </div>
                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/my-info/delete-account")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right"></i>
                                                    <Link to="/my-account/my-info/delete-account" className="nav-link">Delete Your CTBids Account</Link>
                                                </div>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/my-info/personal-info" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/invoice" className="nav-link">Invoice</Link>

                                                <div className="d-flex align-items-center" onClick={() => this.navigate("/my-account/invoice/shipped-items")}>
                                                    <span></span>&ensp;&ensp;<i className="fas fa-angle-right" style={{ color: 'white'}}></i>
                                                    <Link to="/my-account/invoice/shipped-items" className="nav-link">Shipped Items</Link>
                                                </div>
                                             
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/mir" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/mir" className="nav-link">Make It Returnable Status</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/gd" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/gd" className="nav-link">Delivery Guarantee Status</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/my-info/personal-info" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/notification-preferences" className="nav-link">Notification</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/favorite-locations" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/favorite-locations" className="nav-link">Favorite Locations</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/watching" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/watching" className="nav-link">Watching</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/bidding" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/bidding" className="nav-link">Bidding</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/won" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/won" className="nav-link">Won</Link>
                                            </Dropdown.Item>
                                            <Dropdown.Divider />
                                            <Dropdown.Item as={Link} to="/my-account/not-won" style={{ textDecoration: 'none' }}>
                                                <Link to="/my-account/not-won" className="nav-link">Not Won</Link>
                                            </Dropdown.Item>
                                            {/* <Dropdown.Divider /> */}
                                            {/* <Dropdown.Item as={Link} to="/notification" style={{ textDecoration: 'none' }}>
                                                <Link to="/notification" className="nav-link">Notification</Link>
                                            </Dropdown.Item> */}
                                            <Dropdown.Divider />
                                            <Dropdown.Item style={{ textDecoration: 'none' }}>
                                                <div className="d-flex align-items-center justify-content-between" >
                                                    <div onClick={() => this.onLogoutUser()}>
                                                        <div className="nav-link">Sign Out</div>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <div className={`user-details`}>
                                                            <div style={{ color: 'white' }}>
                                                                {`${this.props['user']['lastName'] ? this.props['user']['lastName'] + ', ' : ''}${this.props['user']['firstName'] ? this.props['user']['firstName'] : ''}`}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex profile-border-outer justify-content-center">
                                                            {
                                                                this.props['user']['profileImage'] ?
                                                                    <img src={this.props['user']['profileImage']} alt="profile-image" height="34" width="34" /> :
                                                                    <img src={process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg'} alt="profile-image" height="34" width="34" className="profile" />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                        </div> : <div>
                                            <Dropdown.Divider />
                                            <Dropdown.Item style={{ textDecoration: 'none' }}>
                                                <div onClick={() => this.signInOpen('Sign-In')} className="nav-link">Sign In / Register</div>
                                            </Dropdown.Item>
                                            {/* <Dropdown.Divider /> */}
                                            {/* <Dropdown.Item style={{ textDecoration: 'none' }}>
                                                <div onClick={() => this.signInOpen('Sign-Up')} className="nav-link">Register</div>
                                            </Dropdown.Item> */}
                                        </div>
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                {
                    this.props.user['id'] ?
                        <div className="d-none d-lg-block flex-row header-box border-bottom border-outline sub-header">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center tool-box" style={{ marginLeft: this.state.logoWidth }}>

                                    <div style={{ whiteSpace: "nowrap" }} className={`sub-nav ${this.myAccountActive() ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/my-account/my-info/personal-info')}>
                                        <img className="header-image" src={`${this.myAccountActive() ? myAccountDark : myAccountWhite}`} alt="My account Image"></img> My Account
                                    </div>
                                    <div  style={{ whiteSpace: "nowrap" }} className={`sub-nav ${this.props.location.pathname === '/my-account/favorite-locations' ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/my-account/favorite-locations')}>
                                        <img className="header-image temp-favorite" src={`${this.props.location.pathname === '/my-account/favorite-locations' ? FavoriteDark : FavoriteWhite}`} alt="Favorite Image"></img> Favorite Locations
                                    </div>
                                    <div  style={{ whiteSpace: "nowrap" }} className={`sub-nav ${this.active('watching') ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/my-account/watching')}>
                                        <img className="header-image" src={`${this.active('watching') ? watchingDark : watchingWhite}`} alt="Watching Image"></img> Watching
                                    </div>
                                    <div  style={{ whiteSpace: "nowrap" }} className={`sub-nav ${this.active('bidding') ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/my-account/bidding')}>
                                        <img className="header-image" src={`${this.active('bidding') ? biddingDark : biddingWhite}`} alt="Bidding Image"></img> Bidding
                                    </div>
                                    <div className={`sub-nav ${this.active('won') ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/my-account/won')}>
                                        <img className="header-image" src={`${this.active('won') ? wonDark : wonWhite}`} alt="Won Image"></img> Won
                                    </div>
                                    <div  style={{ whiteSpace: "nowrap" }} className={`sub-nav ${this.active('not-won') ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/my-account/not-won')}>
                                        <img className="header-image" src={`${this.active('not-won') ? notWonDark : notWonWhite}`} alt="Not won Image"></img> Not Won
                                    </div>
                                    {/* <div className={`sub-nav ${this.props.location.pathname === '/notification' ? 'active' : ''} d-flex align-items-center`} onClick={() => this.navigate('/notification')}>
                                        <img className="header-image" src={`${this.props.location.pathname === '/notification' ? notificationDark : notificationWhite}`} alt="Notification"></img> Notification
                                    </div> */}
                                </div>
                                {
                                    this.props.showEstateDetail.show ?
                                        <div className="d-flex align-items-center">
                                            <div className="estate-history">
                                                <OverlayTrigger
                                                    trigger={['hover', 'focus']}
                                                    placement="bottom-end"
                                                    overlay={
                                                        <Popover id={`popover-positioned-estate-history`} className="popover-positioned-estate-history">
                                                            <Popover.Content>
                                                                <div className="header">
                                                                    {this.props.showEstateDetail.extraData?.sale?.title}
                                                                </div>
                                                                <div className="content-body">
                                                                    {this.props.showEstateDetail.extraData?.sale?.provenance}
                                                                </div>
                                                            </Popover.Content>
                                                        </Popover>
                                                    }
                                                >
                                                    <div className="hover-button">Estate History</div>
                                                </OverlayTrigger>
                                            </div>
                                            <div className="ct-location">
                                                <div className="location-popover" ref={this.desciptionPopoverRef}>
                                                    <div className={`hover-button`}
                                                        onMouseEnter={(event) => { this.locationPopoverHanlde(event, 'Main-Div') }}
                                                        onMouseLeave={(event) => { this.locationPopoverHanlde(event, 'Main-Div') }}>
                                                        CT Location
                                                    </div>
                                                    <Overlay
                                                        target={this.state.locationPopoverTarget}
                                                        container={this.desciptionPopoverRef.current}
                                                        placement="bottom-end"
                                                        show={this.state.locationPopoverShow}
                                                    >

                                                        <Popover id={`popover-positioned-ct-location`}
                                                            onMouseEnter={(event) => { this.locationPopoverHanlde(event, 'Popover-Div') }}
                                                            onMouseLeave={(event) => { this.locationPopoverHanlde(event, 'Popover-Div') }}>

                                                            <Popover.Content>
                                                                <div className="caring-transition">
                                                                    <div className="header">
                                                                        Caring Transition Location
                                                                    </div>
                                                                    <div className="body-content">
                                                                        <div className="user-details d-flex align-items-center">
                                                                            {
                                                                                this.props.showEstateDetail.extraData?.locationImage?.filter(x => x.name === 'profile').map((x, index) =>
                                                                                    <img src={x.url} className="phone-icon" alt="phone-icons" key={`location_image_${index}`}></img>
                                                                                )
                                                                            }
                                                                            {
                                                                                this.props.showEstateDetail.extraData?.locationImage?.filter(x => x.name === 'profile').length === 0 ? <img src={image_thumbnail} className="phone-icon" alt="phone-icons" key={`location_image_0`}></img> : null
                                                                            }
                                                                            <div className="name">
                                                                                <div>{this.props.showEstateDetail.extraData?.location?.contactname}</div>
                                                                                <div className="light-color">{titleCase(this.props.showEstateDetail.extraData?.location?.city)}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="email">
                                                                            <i className="fas fa-envelope"></i> {this.props.showEstateDetail.extraData?.location?.email}
                                                                        </div>
                                                                        <div className="phone">
                                                                            <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/phone.svg`} className="phone-icon" alt="phone-icons"></img> {this.props.showEstateDetail.extraData?.location?.phone}
                                                                        </div>
                                                                        <div className="website clickable" onClick={() => this.openInNewTab(this.props.showEstateDetail.extraData?.location?.website)}>
                                                                            <i className="fas fa-globe"></i> <span>Visit Site</span>
                                                                        </div>
                                                                        {
                                                                            isAuthorized() ?
                                                                                <div className="favorite-icon d-flex align-items-center">
                                                                                    <Form.Check onChange={(event) => { this.favoriteLocation(event) }}
                                                                                        checked={this.isFavoriteLocation()}
                                                                                        type="checkbox"
                                                                                        id={`customControlAutosizing`}
                                                                                        label="Favorite Location"
                                                                                        className='favorite-checkbox'
                                                                                        disabled={this.state.locationInProgress}
                                                                                        custom
                                                                                    />
                                                                                    {
                                                                                        this.state.locationInProgress ?
                                                                                            <Spinner animation="border" variant="danger" /> : null
                                                                                    }
                                                                                </div> : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Popover.Content>
                                                        </Popover>
                                                    </Overlay>
                                                </div>
                                            </div>
                                        </div> : null
                                }
                            </div>
                        </div > : null
                }
                <div className={`search-box-slide animate__animated animate__zoomIn ${this.props.searchBoxShow && this.state.globalSearchToggle && this.state.innerWidth < 992 ? '' : 'd-none'}`}>
                    <Form onSubmit={this.viewMoreItems}>
                        <div className={`search-box`}>
                            <div className="input-group">
                                <input className="form-control py-2" id="sale-search-input" aria-label='Search all of CTBids' placeholder="Search all of CTBids" value={this.state.searchValue} onChange={this.onChange}></input>
                                <span className="input-group-append align-items-center clickable" onClick={this.viewMoreItems}>
                                    <i className="fa fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </Form>
                    <div className="buttons d-flex aling-items-center justify-content-center">
                        <Button variant="outline-primary" onClick={this.globalSearchCancel}>Cancel</Button>
                        <Button variant="secondary" onClick={this.viewMoreItems}>
                            Search
                        </Button>
                    </div>
                </div>
                
                <Modal centered show={this.state.notificationShow} size="sm" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton onClick={() => this.setState({notificationShow: false})}>
                        <Modal.Title>Notifications</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div  >
                                <div class="sec">
                                    <div class="txt"></div><div class="clearAll" style={{ cursor: 'pointer' }} onClick={() => this.updateNotication(null)}> Clear All</div>
                                </div>
                                {this.state.notificationList.length > 0 && this.state.notificationList.map(res => {
                                    return (
                                        <div class="sec" key={res.id}>
                                            <div class="txt">{res.description}</div><div closeButton onClick={() => this.updateNotication(res)}> <i className="fa fa-times"  style={{ cursor: 'pointer',color: '#A50050' }} aria-hidden="true"></i></div>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        );
    }
}

export default connect(state => state)(Header);
